import script from "./Accumulative.vue?vue&type=script&setup=true&lang=js"
export * from "./Accumulative.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Accumulative.vue?vue&type=style&index=1&id=3f6ca793&lang=css"

const __exports__ = script;

export default __exports__